module.exports = __webpack_public_path__ + "static/snowmanbooties-ac809b73f1aed7cc08b978ea26842ae9.jpeg";